import { render, staticRenderFns } from "./pushShopGoods.vue?vue&type=template&id=0becbc46&scoped=true&"
import script from "./pushShopGoods.vue?vue&type=script&lang=js&"
export * from "./pushShopGoods.vue?vue&type=script&lang=js&"
import style0 from "./pushShopGoods.vue?vue&type=style&index=0&id=0becbc46&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0becbc46",
  null
  
)

component.options.__file = "pushShopGoods.vue"
export default component.exports